import { render } from "./TakEaway.vue?vue&type=template&id=17fa538c"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/TakEaway.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17fa538c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17fa538c', __exports__)) {
    api.reload('17fa538c', __exports__)
  }
  
  module.hot.accept("./TakEaway.vue?vue&type=template&id=17fa538c", () => {
    api.rerender('17fa538c', render)
  })

}


export default __exports__